interface FilterOptionProps {
  label: string;
  value: string | null;
  selected: boolean;
  optionSetter: (name: string) => void;
}

const FilterOption: React.FC<FilterOptionProps> = ({
  label,
  value,
  selected,
  optionSetter,
}: FilterOptionProps) => {
  const handleClick = (): void => {
    if (selected) {
      optionSetter(null);
    } else {
      optionSetter(value);
    }
  };
  return (
    <span
      className={`cursor-pointer ${selected ? "bg-green-700 text-gray-200" : "no-underline"}`}
      onClick={handleClick}
    >
      {label}
    </span>
  );
};

interface FilterBarProps {
  dateSelected: string | null;
  otherSelected: string | null;
  dateSetter: (name: string) => void;
  otherSetter: (name: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  dateSelected,
  dateSetter,
  otherSelected,
  otherSetter,
}: FilterBarProps): React.ReactElement => {
  return (
    <div className="px-2 flex flex-col text-sm">
      <div>
        <span>By Date: </span>
        <FilterOption
          label="Today"
          value="24h"
          selected={dateSelected === "24h"}
          optionSetter={dateSetter}
        />
        <span> / </span>
        <FilterOption
          label="Last 7 Days"
          value="168h"
          selected={dateSelected === "168h"}
          optionSetter={dateSetter}
        />
        <span> / </span>
        <FilterOption
          label="Last 30 Days"
          value="720h"
          selected={dateSelected === "720h"}
          optionSetter={dateSetter}
        />
      </div>
      <div>
        <span>By Other: </span>
        <FilterOption
          label="Entry point"
          value="entryPoint"
          selected={otherSelected === "entryPoint"}
          optionSetter={otherSetter}
        />
        <span> / </span>
        <FilterOption
          label="No keywords"
          value="nokeywords"
          selected={otherSelected === "nokeywords"}
          optionSetter={otherSetter}
        />
        <span> / </span>
        <FilterOption
          label="No references"
          value="noreferences"
          selected={otherSelected === "noreferences"}
          optionSetter={otherSetter}
        />
      </div>
    </div>
  );
};

export default FilterBar;
